import { createContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    try {
      const token = localStorage.getItem('token');
      const savedUser = localStorage.getItem('user');

      if (!token) return;

      let decoded = null;
      try {
        decoded = jwtDecode(token);
        console.log('Token decodificado en AuthContext', decoded);
      } catch (error) {
        console.error('Error decodificando token:', error);
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        localStorage.removeItem('pgrest_token');
        setUser(null);
        return;
      }

      if (savedUser) {
        try {
          const parsedUser = JSON.parse(savedUser);
          setUser(parsedUser);
          return;
        } catch (error) {
          console.warn('No se pudo leer el user guardado, se usará el token');
        }
      }

setUser({
  id: decoded.id,
  username: decoded.username,
  name: decoded.name || decoded.username,
  role: decoded.role || 'operador',
  team_id: decoded.team_id || null,
  team: decoded.team || null,
  part11_enabled: !!decoded.part11_enabled,
  plan_type: decoded.plan_type || 'gratis',
  plan_status: decoded.plan_status || 'activo',
  alarms_enabled: !!decoded.alarms_enabled,
  max_report_days: decoded.max_report_days ?? 30,
  max_devices: decoded.max_devices ?? 3,
  max_users: decoded.max_users ?? 1,
  permissions: decoded.permissions || []
});


    } catch (error) {
      console.error('Error restaurando sesión:', error);
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      localStorage.removeItem('pgrest_token');
      setUser(null);
    }
  }, []);

  const login = (token, userData = null) => {
    localStorage.setItem('token', token);

    let finalUser = userData;

    if (!finalUser) {
      const decoded = jwtDecode(token);
finalUser = {
  id: decoded.id,
  username: decoded.username,
  name: decoded.name || decoded.username,
  role: decoded.role || 'operador',
  team_id: decoded.team_id || null,
  team: decoded.team || null,
  part11_enabled: !!decoded.part11_enabled,
  plan_type: decoded.plan_type || 'gratis',
  plan_status: decoded.plan_status || 'activo',
  alarms_enabled: !!decoded.alarms_enabled,
  max_report_days: decoded.max_report_days ?? 30,
  max_devices: decoded.max_devices ?? 3,
  max_users: decoded.max_users ?? 1,
  permissions: decoded.permissions || []
}
    }

    localStorage.setItem('user', JSON.stringify(finalUser));
    setUser(finalUser);
    navigate('/seleccionar-tipo');
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    localStorage.removeItem('pgrest_token');
    setUser(null);
    navigate('/');
  };

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
